import { render, staticRenderFns } from "./codeInput2.vue?vue&type=template&id=161ff4e3&scoped=true&"
import script from "./codeInput2.vue?vue&type=script&lang=js&"
export * from "./codeInput2.vue?vue&type=script&lang=js&"
import style0 from "./codeInput2.vue?vue&type=style&index=0&id=161ff4e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ff4e3",
  null
  
)

export default component.exports